import AdGeneration from './AdGeneration';

export default class AdFactory {
    /**
     * インスタンスを返す
     * @param {object} adparam 広告パラメータ
     * @param {string} adType  広告枠
     * @param {object} option  オプション
     */
    static getInstance(adparam, adType, option = {}) {
        switch (adparam.adClass) {
            case 'AdGeneration':
                return new AdGeneration(adparam, adType, option);
            default:
                return null;
        }
    }
}
